import React, { useState, useEffect } from "react";
import {
    Button,
    NavItem,
    NavLink,
    Nav,
    TabContent,
    TabPane,
    Container,
    Row,
    Col,
    UncontrolledTooltip,
} from "reactstrap";
import Axios from "axios";
import icon from "assets/img/moderngambar.png";
import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import ProfilePageHeader from "../../components/Headers/ProfilePageHeader";
import DefaultFooter from "../../components/Footers/DefaultFooter";

function ProfilePage() {
    const [pills, setPills] = useState("2");
    const [dataInfo, setDataInfo] = useState({});
    const [cover, setCover] = useState("");

    useEffect(() => {
        const bodyElement = document.body;
        const htmlElement = document.documentElement;

        // Ensure elements exist before adding classes
        if (bodyElement) {
            bodyElement.classList.add("profile-page");
            bodyElement.classList.add("sidebar-collapse");
        }

        if (htmlElement) {
            htmlElement.classList.remove("nav-open");
        }

        // Ensure the scroll functions are available
        if (window && window.scrollTo) {
            window.scrollTo(0, 0);
        }

        if (bodyElement) {
            bodyElement.scrollTop = 0;
        }

        // Fetch data from API
        const getDataInfo = async () => {
            try {
                const response = await Axios.get(`${process.env.REACT_APP_API_URL}/infoCompany/readInfoCompany`);
                const data = response.data[0];
                setDataInfo(data);
                setCover(data.foto); // Assuming 'cover' image is used somewhere
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        getDataInfo();

        return function cleanup() {
            // Ensure elements exist before removing classes
            if (bodyElement) {
                bodyElement.classList.remove("profile-page");
                bodyElement.classList.remove("sidebar-collapse");
            }
        };
    }, []);

    return (
        <>
            <ExamplesNavbar />
            <div className="wrapper">
                <ProfilePageHeader />
                <div className="section">
                    <Container>
                        {/* Center the image */}
                        <div className="text-center mb-4" data-aos="fade-right">
                            <img
                                src="https://1.bp.blogspot.com/-Rbm_4QLhu3A/YCkivS9l9vI/AAAAAAABI38/_Eas9VSG0H8mmCPgjzFEjXKGAYkqkqnCQCNcBGAsYHQ/s1309/Yayasan%2BKarya.png"
                                alt="Description of the image"
                                className="img-fluid"
                                style={{ width: "40%" }}
                            />
                        </div>
                        {/* Render deskripsi fetched from API */}
                        <div className="description" data-aos="fade-up" data-aos-duration="700">
                            <p className="text-black">
                                <b>
                                    <div dangerouslySetInnerHTML={{ __html: dataInfo.deskripsi }} />
                                </b>
                            </p>
                        </div>
                    </Container>
                </div>
                <DefaultFooter />
            </div>
        </>
    );
}

export default ProfilePage;
